"use client"

import { useInView } from "react-intersection-observer"
import "../assets/css/scotchBonnet.css"
import chiliImage from "../assets/images/scotchBonnet.jpg";

export default function ScotchBonnet() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section ref={ref} className="coming-soon-section">
      <div className="container">
        <div className="coming-soon-grid">
          <div className={`coming-soon-content ${inView ? "visible" : ""}`}>
            <h2 className="coming-soon-title">Scotch Bonnet Chili</h2>
            <p className="coming-soon-description">
              Experience the vibrant heat and fruity flavor of the Scotch Bonnet pepper, a Caribbean favorite renowned for its bold spice and unique taste. Ranging from 100,000 to 350,000 Scoville Heat Units, this pepper brings a fiery kick—up to 70 times hotter than a jalapeño. Perfect for adding authentic Caribbean flair to dishes like jerk chicken, hot sauces, and more.
            </p>

            <div className="coming-soon-features">
              <div className="coming-soon-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">100,000–350,000 Scoville Heat Units</p>
              </div>
              <div className="coming-soon-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">Fruity, bold Caribbean flavor</p>
              </div>
              <div className="coming-soon-feature">
                <div className="feature-bullet"></div>
                <p className="feature-text">Perfect for jerk chicken, hot sauces, and more</p>
              </div>
            </div>
              <a
                className="learn-more-btn"
                href="/learn-more"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn More...
              </a>          
            </div>

          <div className={`coming-soon-image-container ${inView ? "visible" : ""}`}>
            <div className="coming-soon-image">
              <img
                src={chiliImage}
                alt="Hot Chili Sauce"
                width={600}
                height={800}
                className="image"
                style={{ objectFit: "cover", width: "100%", height: "auto" }}
              />
              <div className="coming-soon-badge">Exclusive!</div>
            </div>
          </div>
        </div>
      </div>

      {/* Animated background elements */}
      <div className="animated-bg animated-bg-1"></div>
      <div className="animated-bg animated-bg-2"></div>
    </section>
  )
}
